module.exports = __webpack_public_path__ + "assets/media/lunch.94f7b5f9.mp3";